import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { getComposeStore } from 'owa-calendar-compose-store-manager';
import {
    getCalendarColorScheme as getCalendarColorSchemeFromModule,
    getCalendarEventColorScheme,
} from 'owa-calendar-color-resolver';
import { getDefaultCalendar } from 'owa-calendar-cache';

/**
 * Returns the calendar color scheme for the event in the compose form
 */
export function getComposeCalendarColorScheme(): ColorScheme {
    let store = getComposeStore();
    if (store.event?.ParentFolderId) {
        return getCalendarEventColorScheme(store.event);
    }

    // If parentFolderId is not set (compose scenario), then get default calendar's color scheme
    return getCalendarColorSchemeFromModule(getDefaultCalendar().id);
}
